import { api } from '@/shared/api'
import type { Leaderboard, LeaderPeriod } from './types'

/**
 * Таблицы лидеров за период.
 *
 * Ответ кешируется сервером на десять минут (App\Services\Stats\Leaderboard),
 * поэтому свой staleTime здесь не нужен: чаще, чем обновляется рейтинг,
 * ходить всё равно некуда.
 */
export async function fetchLeaderboard(period: LeaderPeriod): Promise<Leaderboard> {
  const { data } = await api.get<Leaderboard>('/leaderboard', { params: { period } })

  return data
}
